import {DropdownNestedMenuContentProps} from './types'
import DropdownNestedMenuContentView from './DropdownNestedMenuContentView'
import React from 'react'

const DropdownNestedMenuContent = (props: DropdownNestedMenuContentProps) => <DropdownNestedMenuContentView {...props} />

export default DropdownNestedMenuContent
